const loadingAnimationActionTypes = {
	START_LOADING: "START_LOADING",
	STOP_LOADING: "STOP_LOADING",
};
export default loadingAnimationActionTypes;
